import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { changePassword } from "../lib/api";

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (next.length < 6) {
      toast.error("A nova senha deve ter ao menos 6 caracteres.");
      return;
    }
    if (next !== confirm) {
      toast.error("A confirmação não corresponde à nova senha.");
      return;
    }
    try {
      setLoading(true);
      await changePassword(current, next);
      toast.success("Senha alterada com sucesso!");
      setOpen(false);
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Não foi possível alterar a senha.";
      toast.error(typeof msg === "string" ? msg : "Não foi possível alterar a senha.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          data-testid="open-change-password-button"
          className="h-8 w-8 rounded-full text-muted-foreground"
          aria-label="Trocar senha"
        >
          <KeyRound className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Trocar senha de admin</DialogTitle>
          <DialogDescription>
            Defina uma nova senha para acessar o painel. Mínimo de 6 caracteres.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-2">
          <div>
            <Label htmlFor="cur-pw" className="mb-2 block text-sm">Senha atual</Label>
            <Input
              id="cur-pw"
              type="password"
              data-testid="current-password-input"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              className="h-11 rounded-xl"
            />
          </div>
          <div>
            <Label htmlFor="new-pw" className="mb-2 block text-sm">Nova senha (mín. 6 caracteres)</Label>
            <Input
              id="new-pw"
              type="password"
              data-testid="new-password-input"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              className="h-11 rounded-xl"
            />
          </div>
          <div>
            <Label htmlFor="confirm-pw" className="mb-2 block text-sm">Confirmar nova senha</Label>
            <Input
              id="confirm-pw"
              type="password"
              data-testid="confirm-password-input"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="h-11 rounded-xl"
            />
          </div>
          <DialogFooter>
            <Button
              type="submit"
              data-testid="submit-change-password-button"
              disabled={loading}
              className="w-full rounded-xl"
            >
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <KeyRound className="mr-2 h-4 w-4" />}
              Salvar nova senha
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
